import { BULK_BIDDING_CSV_FIELDS } from './bulkBiddingCSV.const';
import { BulkBiddingUploadCSVSchema } from './BulkBiddingUploadCSVSchema';
import type { MotorwayVehicleUrl, ValidatedCSVEntries } from './validateCSVEntries.types';

const getEnquiryFromVehicleUrl = (url: MotorwayVehicleUrl) => {
	return url.split('/').pop()!;
};

export const validateCSVEntries = (rows: Record<string, string>[]): ValidatedCSVEntries => {
	return rows.reduce<ValidatedCSVEntries>(
		(acc, row) => {
			const validation = BulkBiddingUploadCSVSchema.safeParse(row);

			if (validation.success) {
				acc.valid.push({
					bidAmount: validation.data[BULK_BIDDING_CSV_FIELDS.BID_AMOUNT],
					csvData: row,
					enquiryId: getEnquiryFromVehicleUrl(validation.data[BULK_BIDDING_CSV_FIELDS.VEHICLE_LINK]),
				});
			} else {
				const validationErrors = validation.error.flatten((issue) => ({
					errorCode: issue.code,
					message: issue.message,
				})).fieldErrors;

				// We need the link to fetch vehicles so errors with the link should be ignored
				if (validationErrors[BULK_BIDDING_CSV_FIELDS.VEHICLE_LINK]) {
					acc.ignored.push({
						csvData: row,
						errors: validationErrors,
					});
				} else {
					acc.invalid.push({
						csvData: row,
						enquiryId: getEnquiryFromVehicleUrl(row[BULK_BIDDING_CSV_FIELDS.VEHICLE_LINK] as MotorwayVehicleUrl),
						errors: validationErrors,
					});
				}
			}
			return acc;
		},
		{ ignored: [], invalid: [], valid: [] },
	);
};
